export default "__VITE_ASSET__7793e1b5__"